export const UPDATE_CUSTOMER = 'customerReducer/UPDATE_CUSTOMER';
export type UPDATE_CUSTOMER = typeof UPDATE_CUSTOMER;

export const CLEAR_CUSTOMER = 'customerReducer/CLEAR_CUSTOMER';
export type CLEAR_CUSTOMER = typeof CLEAR_CUSTOMER;


// WEBPACK FOOTER //
// ./src/modules/customer/constants.ts